import type { FigmaIconProps } from './types';

export const IconFigmaInfoNote = ({ size = 16, color = 'currentColor' }: FigmaIconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ display: 'block', flexShrink: 0 }}
  >
    <path
      d="M14.6667 8C14.6667 11.6819 11.6819 14.6667 8 14.6667C4.3181 14.6667 1.33333 11.6819 1.33333 8C1.33333 4.3181 4.3181 1.33333 8 1.33333C11.6819 1.33333 14.6667 4.3181 14.6667 8Z"
      stroke={color}
      strokeWidth="1.33333"
    />
    <path d="M8 10.6667V8" stroke={color} strokeWidth="1.33333" strokeLinecap="round" />
    <path d="M8 5.33333H8.00667" stroke={color} strokeWidth="1.33333" strokeLinecap="round" />
  </svg>
);
